import GrimoireInterfaceImpl from "./GrimoireInterfaceImpl";
import GomlInterfaceImpl from "./GomlInterfaceImpl";
const context = new GrimoireInterfaceImpl();
function obtainGomlInterface(query) {
    if (typeof query === "string") {
        const gomlContext = new GomlInterfaceImpl(context.queryRootNodes(query));
        const queryFunc = gomlContext.queryFunc.bind(gomlContext);
        Object.setPrototypeOf(queryFunc, gomlContext);
        return queryFunc;
    }
    else if (typeof query === "function") {
        if (context.callInitializedAlready) {
            query();
        }
        else {
            context.initializedEventHandler.push(query);
        }
    }
    else {
        const gomlContext = new GomlInterfaceImpl(query);
        const queryFunc = gomlContext.queryFunc.bind(gomlContext);
        Object.setPrototypeOf(queryFunc, gomlContext);
        return queryFunc;
    }
}
Object.setPrototypeOf(obtainGomlInterface, context);
export default obtainGomlInterface;



// WEBPACK FOOTER //
// ./src/Interface/GrimoireInterface.ts